import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import appInfo from '../../constants/appInfo';
import navLinks from '../../constants/navigation';
import logowhitecolor from '../../images/logowhitecolor.png';
import logoName from '../../images/logo-name.png';
import namedarkcolor from '../../images/name-dark-color.png';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const handleNavClick = (href) => {
    if (isHome && href.startsWith('#')) {
      const id = href.slice(1);
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__inner container">

        {/* ── Brand column ── */}
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img
              src={logowhitecolor}
              alt="Dhenika logo"
              className="footer__logo-mark"
            />
            <img
              src={namedarkcolor}
              alt="Dhenika"
              className="footer__logo-name"
            />
          </Link>
          <p className="footer__tagline">{appInfo.shortDescription}</p>
          <a
            href={`mailto:${appInfo.supportEmail}`}
            className="footer__email"
          >
            {appInfo.supportEmail}
          </a>
        </div>

        {/* ── Quick links ── */}
        <div className="footer__section">
          <h4 className="footer__heading">Quick Links</h4>
          <ul className="footer__list">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={isHome ? link.href : `/${link.href}`}
                  className="footer__link"
                  onClick={() => handleNavClick(link.href)}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Legal ── */}
        <div className="footer__section">
          <h4 className="footer__heading">Legal</h4>
          <ul className="footer__list">
            <li><Link to="/privacy" className="footer__link">Privacy Policy</Link></li>
            <li><Link to="/delete-account" className="footer__link">Delete Account</Link></li>
            <li><Link to="/contact" className="footer__link">Contact Us</Link></li>
          </ul>
        </div>

        {/* ── Download ── */}
        <div className="footer__section">
          <h4 className="footer__heading">Get the App</h4>
          <div className="footer__store-btns">
            <a
              href={appInfo.playStoreUrl}
              className="footer__store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              🤖 Google Play
            </a>
            <span
              className="footer__store-btn footer__store-btn--disabled"
              aria-disabled="true"
            >
              🍎 App Store <em>— Coming Soon</em>
            </span>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer__bottom">
        <div className="container">
          <p>© {year} {appInfo.name}. Made with ❤️ for Indian farmers.</p>
          <p>All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;